export const blockIconsSocialGroup = (
	<span className='material-symbols-outlined'>group</span>
);
